import React, { useState, useRef, useEffect } from 'react';
import InvoicesManager from '../../../components/CMS/InvoicesManager/InvoicesManager';
import PaymentReceiptsManager from '../../../components/CMS/PaymentReceiptsManager/PaymentReceiptsManager';
import QuotationsManager from '../../../components/CMS/QuotationsManager/QuotationsManager';
import ClientsManager from '../../../components/CMS/ClientsManager/ClientsManager';
import ExpensesManager from '../../../components/CMS/ExpensesManager/ExpensesManager';
import './AdminDashboard.css';
import logo from '../../../assets/logos/logo.png';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const menuItems = [
    { id: 'overview', label: 'Overview' },
    { id: 'invoices', label: 'Invoices' },
    { id: 'receipts', label: 'Receipts' },
    { id: 'quotations', label: 'Quotations' },
    { id: 'clients', label: 'Clients' },
    { id: 'expenses', label: 'Expenses' },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewSection setActiveTab={setActiveTab} />;
      case 'invoices':
        return <InvoicesManager />;
      case 'receipts':
        return <PaymentReceiptsManager />;
      case 'quotations':
        return <QuotationsManager />;
      case 'clients':
        return <ClientsManager />;
      case 'expenses':
        return <ExpensesManager />;
      default:
        return <OverviewSection setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Top Navigation Bar */}
      <nav className="admin-navbar">
        <div className="admin-navbar-logo" onClick={() => window.open('/', '_blank', 'noopener,noreferrer')}>
          <img src={logo} alt="Skript Logo" />
          <span>Skript Admin</span>
        </div>

        <div className="admin-navbar-links">
          {menuItems.map(item => (
            <button
              key={item.id}
              className={`admin-navbar-link ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(item.id);
                setMobileMenuOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>



        <button
          ref={hamburgerRef}
          className="admin-navbar-hamburger"
          onClick={toggleMobileMenu}
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>

        {mobileMenuOpen && (
          <div ref={menuRef} className="admin-navbar-mobile-menu active">
            {menuItems.map(item => (
              <button
                key={item.id}
                className={`admin-navbar-link ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(item.id);
                  setMobileMenuOpen(false);
                }}
              >
                {item.label}
              </button>
            ))}

          </div>
        )}
      </nav>
      
      {/* Main Content */}
      <div className="admin-main-content">
        <div className="admin-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

const OverviewSection = ({ setActiveTab }) => {
  return (
    <div className="overview-section">
      <div className="overview-cards">
        <div className="overview-card">
          <div className="card-content">
            <h3>Total Invoices</h3>
            <p className="card-number">0</p>
            <span className="card-label">This month</span>
          </div>
        </div>
        
        <div className="overview-card">
          <div className="card-content">
            <h3>Quotations</h3>
            <p className="card-number">0</p>
            <span className="card-label">Pending</span>
          </div>
        </div>
        
        <div className="overview-card">
          <div className="card-content">
            <h3>Active Clients</h3>
            <p className="card-number">0</p>
            <span className="card-label">Total</span>
          </div>
        </div>
        
        <div className="overview-card">
          <div className="card-content">
            <h3>Expenses</h3>
            <p className="card-number">$0</p>
            <span className="card-label">This month</span>
          </div>
        </div>
      </div>
      
      <div className="overview-welcome">
        <h2>Skript Admin Dashboard</h2>
        <p>Skript empowers your business with tailored digital solutions.<br />
From websites to mobile apps and desktop software,<br />
we build it all — fast, smart, and scalable.</p>
        <div className="quick-actions">
          <button 
            className="quick-action-btn" 
            onClick={() => setActiveTab('invoices')}
          >
            Create New Invoice
          </button>
          <button 
            className="quick-action-btn" 
            onClick={() => setActiveTab('quotations')}
          >
            Generate Quotation
          </button>
          <button 
            className="quick-action-btn" 
            onClick={() => setActiveTab('clients')}
          >
            Add Client
          </button>
          <button 
            className="quick-action-btn" 
            onClick={() => setActiveTab('expenses')}
          >
            Record Expense
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 